import randomElement from "../randomElement";

function YesNo(minigameData){
    let data = randomElement(minigameData.data.questions);
    return {
        question: data.qst,
        options: ['Да', 'Нет'],
        correct: data.ans,
        type: 'Question'
    }
}

export default YesNo;